import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ResolveActivationDialogComponent } from './resolve-dialog/resolve-dialog.component';
import { PendingAccountsService } from './pending-accounts.service';
import { OrderFormDialogModule } from '../account-order-form-dialog/order-form-dialog.module';

@NgModule({
  imports: [SharedModule, OrderFormDialogModule],
  declarations: [ResolveActivationDialogComponent],
  exports: [ResolveActivationDialogComponent],
  providers: [PendingAccountsService],
})
export class PendingAccountsModule {}
